export default __webpack_public_path__ + "static/media/vip-5.172715f5.gif";